import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import GroupsEmpty from './GroupsEmpty';

import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import { vaccineGroupService } from '../../../_services/vaccine-group.service';

const columns = [
  {
    name: 'ID',
    sort: false,
    cell: group => group.groupId,
    grow: 1
  },
  {
    name: 'Name',
    sort: false,
    cell: group => group.name,
    grow: 2
  },
  {
    name: 'Group Code',
    sort: false,
    cell: group => group.code,
    grow: 2
  },
  {
    name: <span className="badge bg-info text-white">WAITLIST</span>,
    sort: false,
    selector: 'waitlist'
  },
  {
    name: <span className="badge bg-warning">PENDING</span>,
    sort: false,
    selector: 'pending'
  },
  {
    name: <span className="badge bg-success text-white">SCHEDULED</span>,
    sort: false,
    selector: 'scheduled'
  },
  {
    button: true,
    sort: false,
    cell: group => {
      return <Link to={`/vaccine/groups/${group.groupId}/reservations`}>Reservations</Link>
    }
  }
]

export default function Groups() {
  const dispatch = useDispatch();

  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initLoad, setInitLoad] = useState(true)

  useEffect(() => {
    vaccineGroupService.getAll()
      .then(groups => {
        setLoading(false);
        setGroups(groups)
        setInitLoad(false)
      })
      .catch(() => {
        setLoading(false);
        dispatch(alertActions.error('Could not load vaccine groups. Please try again.'));
      });
  }, [dispatch]);

  return <div className="mt-4">
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item active" aria-current="page">Groups</li>
      </ol>
    </nav>

    {initLoad && loading ?
      <Spinner animation="border" role="status" />
      :
      initLoad && groups.length === 0 ?
        <GroupsEmpty />
        :
        <DataTable
          title="Group List"
          actions={<Link to="/vaccine/groups/create" className="btn btn-primary">Create Group</Link>}
          columns={columns}
          data={groups}
          progressPending={loading}
          striped={true}
          customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
        />
    }
  </div>
}